import { h as v, me as i, u$1 as m, Y as h, m as b, o as g } from "../chunks/register-Ba9sFUKZ.js";
import * as p from "react";
import { f as B } from "../chunks/query-assigned-elements-CMnZBBH0.js";
import { d as E } from "../chunks/lifecycle-decorators-C04d1yHY.js";
const d = {
  beaconTagName: "beacon-segmented-control"
};
var f = Object.defineProperty, y = Object.getOwnPropertyDescriptor, r = (n, o, a, c) => {
  for (var t = c > 1 ? void 0 : c ? y(o, a) : o, s = n.length - 1, l; s >= 0; s--)
    (l = n[s]) && (t = (c ? l(o, a, t) : l(t)) || t);
  return c && t && f(o, a, t), t;
};
const u = class extends i {
  constructor() {
    super(...arguments), this.beaconTagName = d.beaconTagName, this.selected = !1, this.value = "";
  }
  get text() {
    var o, a;
    return (a = (o = this.innerText) == null ? void 0 : o.trim()) != null ? a : "";
  }
  /** Normalized text content to remove any spaces so it remains a continuous string. */
  get normalizedValue() {
    return this.value || this.text.replace(" ", "-") || "";
  }
  get icon() {
    return this.icons[0];
  }
  handleSlotChange() {
    m(this, "beacon-event-change");
  }
  render() {
    return h`
      <slot name="icon"></slot>
      <slot @slotchange="${this.handleSlotChange}></slot>
    `;
  }
};
u.tagName = d.beaconTagName;
let e = u;
r([
  v({ type: Boolean })
], e.prototype, "selected", 2);
r([
  v()
], e.prototype, "value", 2);
r([
  B({ slot: "icon" })
], e.prototype, "icons", 2);
r([
  E
], e.prototype, "handleSlotChange", 1);
const S = (n) => (b(n, e), g({
  tagName: n ? n + "-" + e.tagName : e.tagName,
  elementClass: e,
  react: p,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  S as default,
  S as reactBeaconSegmentedControl
};
